import { Link, NavLink, useLocation } from "react-router-dom";
import {
  Archivesvg,
  Dashboardsvg,
  Newslettersvg,
  SidebarCatchRetirn,
  SidebarCompitition,
  SidebarMapParking,
  SidebarMember,
  SidebarRulesRegulations,
} from "../../SvgFile/Index";
import { useEffect, useState } from "react";
import Logout from "../../Component/Pages/Auth/Logout";
import SideBarLink from "../SideBarLink";
import { isCommitteeMember } from "../../helpers/auth";

const FALLBACK_PHOTO = "https://cdn-icons-png.flaticon.com/512/149/149071.png";

const MEMBER_LINKS = [
  {
    url: "/member/catch-return",
    roleName: "Submit Catch Return",
    icon: <SidebarCatchRetirn />,
  },
  {
    url: "/maps-parking-info",
    roleName: "Maps & Parking Info",
    icon: <SidebarMapParking />,
  },
  {
    url: "/rules-regulations",
    roleName: "Rules & Regulations",
    icon: <SidebarRulesRegulations />,
  },
  {
    url: "/competitions-dinners",
    roleName: "Competitions, Invitations & Events",
    icon: <SidebarCompitition />,
  },
  {
    url: "/member/newsletters",
    roleName: "Newsletters",
    icon: <Newslettersvg />,
  },
  {
    url: "/member/club-archive",
    roleName: "Club Archive",
    icon: <Archivesvg />,
  },
];

function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem("memberData")) || null;
  } catch {
    return null;
  }
}

function closeSidebar() {
  localStorage.setItem("sidebarOpen", "false");
  window.dispatchEvent(new Event("storage")); // MemberLayout listens to this
}

export default function Sidebar() {
  const [open, setOpen] = useState(false);
  const [user] = useState(getStoredUser);
  const location = useLocation();

  const isProfilePage = location.pathname === "/member/profile-details";

  const handleClose = () => setOpen(false);

  // Close the sidebar whenever the route changes
  useEffect(() => {
    closeSidebar();
  }, [location.pathname]);

  // Also close when any link in the menu is clicked, even if it points to the current page
  const handleMenuClick = (e) => {
    if (e.target.closest("a")) {
      closeSidebar();
    }
  };

  const isPhotoEnabled =
    localStorage.getItem("memberProfilePhotoKey") === "true";

  const displayPhoto =
    isPhotoEnabled && user?.picture?.url ? user.picture.url : FALLBACK_PHOTO;

  return (
    <div className="main_container">
      <div className="intersight_menu">
        <button
          type="button"
          className="mobile_cross w-100 text-end border-0 bg-transparent"
          aria-label="Close sidebar"
          onClick={closeSidebar}
        >
          <svg
            width={24}
            height={24}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path
              fill="#000000"
              d="M15.71,8.29a1,1,0,0,0-1.42,0L12,10.59,9.71,8.29A1,1,0,0,0,8.29,9.71L10.59,12l-2.3,2.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l2.29,2.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L13.41,12l2.3-2.29A1,1,0,0,0,15.71,8.29Zm3.36-3.36A10,10,0,1,0,4.93,19.07,10,10,0,1,0,19.07,4.93ZM17.66,17.66A8,8,0,1,1,20,12,7.95,7.95,0,0,1,17.66,17.66Z"
            />
          </svg>
        </button>

        <div className="top_menu">
          <div className="brand">
            <button
              className="border-0 w-100 d-flex align-items-center"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="d-flex align-items-center justify-content-center">
                <img src="/image/fish.svg" alt="" className="img-fluid" />
              </span>
              <div className="brand_dashboard">
                <span>Glendale Grayling Club</span>
                <h6>Est. 1838</h6>
              </div>
            </button>
          </div>

          <div className="intersight_home">
            <div className="menu_div user_menu" onClick={handleMenuClick}>
              <ul>
                <li>
                  <NavLink
                    to="/member/dashboard"
                    className={({ isActive }) =>
                      isActive || isProfilePage ? "active" : ""
                    }
                  >
                    <span>
                      <Dashboardsvg />
                    </span>{" "}
                    Dashboard
                  </NavLink>
                </li>

                <li className="without_label">Workspace</li>
              </ul>

              <ul className="menu_scrollbar">
                {MEMBER_LINKS.map((item) => (
                  <SideBarLink
                    key={item.url}
                    href={item.url}
                    name={item.roleName}
                    icon={item.icon}
                  />
                ))}
                {isCommitteeMember() && (
                  <>
                    <li className="without_label">Committee member</li>
                    <li>
                      <NavLink
                        to="/check-member-info"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <span>
                          <SidebarMember />
                        </span>{" "}
                        Check Member Info
                      </NavLink>
                    </li>
                  </>
                )}
              </ul>

              <div className="bottom_menu">
                <div className="dropdown">
                  <button
                    className="dropdown-toggle border-0 w-100 d-flex align-items-center"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <span className="d-flex align-items-center justify-content-center person_icon">
                      <img
                        src={displayPhoto}
                        alt=""
                        className="img-fluid"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = FALLBACK_PHOTO;
                        }}
                      />
                    </span>
                    <span className="person_name">
                      {user?.firstName} {user?.surname}
                      <span className="d-block">
                        {user?.status
                          ? user.status
                              .replace(/_/g, " ")
                              .replace(/\b\w/g, (c) => c.toUpperCase())
                          : ""}
                        &nbsp;
                      </span>
                    </span>
                  </button>
                  <ul className="dropdown-menu w-100">
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/member/profile-details"
                      >
                        View Stored Details
                      </Link>
                    </li>
                    <li>
                      <button
                        type="button"
                        className="dropdown-item"
                        onClick={() => setOpen(true)}
                      >
                        Logout
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Logout open={open} handleClose={handleClose} />
    </div>
  );
}
